<template>
  <div class="h-full flex flex-col">
    <!-- ヘッダー部 -->
    <div class="w-full bg-white border-b-[1px] border-gray200">
      <div class="flex w-full items-center h-[70px] pl-3 pr-5">
        <img
          src="@/assets/Icon_Left_grayV2.svg"
          class="w-6 h-6 mr-2"
          @click="goToBackPage()"
        />
        <!-- タグ/投稿者検索 -->
        <div
          class="p-4 h-fit flex items-center flex-1 bg-gray200 rounded-[8px]"
        >
          <img src="@/assets/Icon_Route_Glasses_black.svg" class="w-4 h-4" />
          <div class="flex-1 relative h-4">
            <div class="absolute w-full left-0 h-[15px] pl-2 text-left">
              <div class="text-W4 text-[15px] leading-[15px] truncate">
                {{ `#${selectTag}` }}
              </div>
            </div>
            <input
              type="text"
              class="absolute w-full left-0 opacity-0"
              readonly
              @click="isShowTagSearchSuggest = true"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="border-t-[1px] border-gray300" />
    <!-- Topに戻るボタン -->
    <ScrollTopButton
      targetId="tag-search-result-contents"
      class="fixed bottom-[72px] right-5"
    />
    <!-- 検索結果 -->
    <div
      class="flex-1 overflow-y-auto overscroll-none bg-gray200"
      id="tag-search-result-contents"
      ref="scrollContainer"
    >
      <div class="h-2 w-full" />
      <PullToRefreshAndPagination
        @refresh="handleRefresh"
        @pagination="handlePagination"
        @scroll="handleScroll"
        ref="tagSearchResult"
      >
        <template v-if="isFetchFailed">
          <div class="mt-16">
            <div class="text-W4 text-gray400 text-[13px] leading-[23px]">
              投稿を取得できませんでした
            </div>
            <div class="my-4 flex justify-center">
              <img :src="errorSrc" class="h-[140px] w-[140px]" />
            </div>
            <TheButton
              text="再読み込み"
              class="m-auto w-[123px]"
              @click-button="initialCommentList()"
            />
          </div>
        </template>
        <template v-else>
          <div v-for="(comment, index) in commentList" :key="comment.commentId">
            <div v-if="index !== 0" class="h-2 w-full bg-gray200" />
            <CommentCardForTagResult
              :comment="comment"
              @on-click-comment="goToSpotDetail(comment)"
            />
          </div>
        </template>
      </PullToRefreshAndPagination>
      <div class="h-[80px] w-full bg-gray200" />
    </div>
    <!-- タグ検索パネル -->
    <TagSearchSuggest
      :isShowTagSearchSuggest="isShowTagSearchSuggest"
      @click-back-button="isShowTagSearchSuggest = false"
      @select-tag="reSearchTag($event)"
    />
  </div>
</template>

<script>
import CommentCardForTagResult from '@/components/organisms/dokoiku/CommentCardForTagResult.vue'
import PullToRefreshAndPagination from '@/components/molecules/PullToRefreshAndPagination.vue'
import TheButton from '@/components/atoms/TheButton.vue'
import TagSearchSuggest from '@/components/organisms/dokoiku/TagSearchSuggest.vue'
import Util from '@/mixins/util'
import {goBackDokoiku, navigateTo, META_TAB} from '@/router'
import ScrollTopButton from '@/components/atoms/ScrollTopButton.vue'
import log from 'loglevel'
const TagSearchResult = {
  name: 'TagSearchResult',
  components: {
    CommentCardForTagResult,
    PullToRefreshAndPagination,
    TheButton,
    TagSearchSuggest,
    ScrollTopButton,
  },
  data() {
    return {
      isShowTagSearchSuggest: false, // タグ検索パネル表示フラグ
      errorSrc: Util.methods.getErrorAssetsSrc(), // 検索失敗時の画像パス
    }
  },
  computed: {
    /**
     * タイムライン記事情報
     */
    commentList: {
      get() {
        return this.$store.state.DokoikuStore.tagSearchResult.commentList
      },
      set(value) {
        let newList = []
        /* eslint-disable-next-line no-magic-numbers*/
        if (this.offset === 0) {
          // 先頭ページ読み込みの場合、新しく置き換え
          newList = value
        } else {
          // 続きのページ読み込みの場合、タイムライン追加
          const currentCommentList =
            this.$store.state.DokoikuStore.tagSearchResult.commentList
          const tmpCommentList = structuredClone(currentCommentList)
          tmpCommentList.push(...value)
          newList = tmpCommentList
        }
        this.$store.commit('DokoikuStore/setTagSearchResultInfo', {
          key: 'commentList',
          value: newList,
        })
      },
    },
    /**
     * ページネーション情報
     */
    offset: {
      get() {
        return this.$store.state.DokoikuStore.tagSearchResult.offset
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTagSearchResultInfo', {
          key: 'offset',
          value: value,
        })
      },
    },
    /**
     * タグ検索にて選択したタグ名
     */
    selectTag: {
      get() {
        return this.$store.state.DokoikuStore.tagSearchResult.selectTag
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTagSearchResultInfo', {
          key: 'selectTag',
          value: value,
        })
      },
    },
    /**
     * タイムライン取得失敗有無
     */
    isFetchFailed: {
      get() {
        return this.$store.state.DokoikuStore.tagSearchResult.isFetchFailed
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTagSearchResultInfo', {
          key: 'isFetchFailed',
          value: value,
        })
      },
    },
    /**
     * スクロール位置
     */
    scrollPosition: {
      get() {
        return this.$store.state.DokoikuStore.tagSearchResult.scrollPosition
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTagSearchResultInfo', {
          key: 'scrollPosition',
          value: value,
        })
      },
    },
    /**
     * 位置情報
     */
    currentPosition: {
      get() {
        const {lat, lon} = this.$store.state.currentPosition
        return {lat, lon}
      },
    },
    /**
     * 保持している位置情報
     */
    keepPosition: {
      get() {
        return this.$store.state.DokoikuStore.tagSearchResult.coord
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTagSearchResultInfo', {
          key: 'coord',
          value: value,
        })
      },
    },
  },
  mounted() {
    const el = document.getElementById('tag-search-result-contents')
    el.addEventListener('scroll', this.$refs.tagSearchResult.handleScroll)
  },
  async activated() {
    const prevPageMeta = this.$route.params.prevMeta
    const isGoBack = this.$route.params.isGoBack || false
    // ドコイク機能の画面内遷移で、前に進む遷移を行った場合は情報の更新を行う
    if (!isGoBack && prevPageMeta.tab == META_TAB.DOKOIKU) {
      await this.initialCommentList()
    }
    // アクティブになったタイミングで、スクロール位置を元の状態に切り替える。
    this.$nextTick(() => {
      this.$refs.scrollContainer.scrollTop = this.scrollPosition
    })
  },
  methods: {
    /**
     * タグ再検索
     * @param {String} tag タグ名
     */
    reSearchTag(tag) {
      this.isShowTagSearchSuggest = false
      // 表示内容初期化 + 新しい検索タグを設定
      this.$store.commit('DokoikuStore/initTagSearchResultInfo')
      this.selectTag = tag
      // タグ検索実行
      this.initialCommentList()
    },
    /**
     * タイムライン記事更新処理
     * @param {Number} offset 次投稿データ開始位置
     * @param {Object} coord 座標情報
     * @param {Number} coord.lat 緯度
     * @param {Number} coord.lon 経度
     * @returns {Array} 取得した記事情報
     */
    fetchCommentList(offset, coord) {
      // APIに連携する前に、小数点以下第7位以降を切り捨て
      const convertCoordSixDecimal = (value) => {
        // eslint-disable-next-line no-magic-numbers
        return Number.parseFloat(value).toFixed(6)
      }
      return new Promise((resolve, reject) => {
        this.$store.dispatch('DokoikuStore/fetchSpotList', {
          success: (result) => {
            resolve(result)
          },
          failed: () => {
            reject()
          },
          error: (e) => {
            reject(e)
          },
          filter: {
            // 検索条件 タグ
            tag: this.selectTag,
          },
          sort: {
            kind: 'distance',
            currentCoord: `${convertCoordSixDecimal(
              coord.lat
            )},${convertCoordSixDecimal(coord.lon)}`,
            order: 'asc',
          },
          // オフセット POSTなので、渡す前に文字列変換
          offset: String(offset),
        })
      })
    },
    /**
     * 初回表示時のタイムライン記事更新処理
     */
    async initialCommentList() {
      this.$store.commit('startLoading')
      try {
        // 現在の位置情報を取得
        const defaultLat = this.$config.DEFAULT_CURRENT_POSITION.LAT
        const defaultLon = this.$config.DEFAULT_CURRENT_POSITION.LON
        const coord = {
          lat: this.currentPosition.lat || defaultLat,
          lon: this.currentPosition.lon || defaultLon,
        }
        const {item} = await this.fetchCommentList(this.offset, coord)
        /* eslint-disable-next-line no-magic-numbers*/
        if (item.length === 0) throw new Error()

        this.commentList = item
        this.offset = this.commentList.length
        this.isFetchFailed = false
        // リフレッシュ時点の位置情報を保持
        this.keepPosition = structuredClone(coord)
      } catch (e) {
        // 取得失敗処理
        this.isFetchFailed = true
        this.commentList = []
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、エラーをスローする
          throw e
        }
      } finally {
        this.$store.commit('endLoading')
      }
    },
    /**
     * リフレッシュ操作時処理
     * @param {Function} refreshDone 終了処理
     */
    async handleRefresh(refreshDone) {
      // ページを先頭に戻し、投稿一覧を更新
      this.offset = 0
      try {
        // 現在の位置情報を取得、なければ東京駅を基準にする
        const defaultLat = this.$config.DEFAULT_CURRENT_POSITION.LAT
        const defaultLon = this.$config.DEFAULT_CURRENT_POSITION.LON
        const coord = {
          lat: this.currentPosition.lat || defaultLat,
          lon: this.currentPosition.lon || defaultLon,
        }
        const {item} = await this.fetchCommentList(this.offset, coord)
        /* eslint-disable-next-line no-magic-numbers*/
        if (item.length === 0) throw new Error()
        this.commentList = item
        this.offset = this.commentList.length
        this.isFetchFailed = false
        // リフレッシュ時点の位置情報を保持
        this.keepPosition = structuredClone(coord)
      } catch (e) {
        // 取得失敗処理
        this.isFetchFailed = true
        this.commentList = []
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、終了処理を行った上エラーをスローする
          refreshDone()
          throw e
        }
      }
      refreshDone()
    },
    /**
     * ページネーション操作時処理
     * @param {Function} paginationDone 終了処理 引数:スクロール対象要素ID
     */
    async handlePagination(paginationDone) {
      // ページを更新し、投稿一覧を追加
      const prevPage = structuredClone(this.offset)
      try {
        // 前回の位置情報を取得
        const coord = {lat: this.keepPosition.lat, lon: this.keepPosition.lon}
        const {item} = await this.fetchCommentList(this.offset, coord)
        /* eslint-disable-next-line no-magic-numbers*/
        if (item.length === 0) throw new Error()

        this.commentList = item
        this.offset = this.commentList.length
      } catch (e) {
        // 取得失敗処理
        // 元のページに戻す
        this.offset = prevPage
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、終了処理を行った上エラーをスローする
          paginationDone('tag-search-result-contents')
          throw e
        }
      }
      paginationDone('tag-search-result-contents')
    },
    /**
     * タイムラインスクロール処理
     * @param {Number} scrollTop スクロール位置
     */
    handleScroll(scrollTop) {
      this.scrollPosition = scrollTop
    },
    /**
     * 地点詳細画面へ遷移
     * @param {Object} comment 投稿情報
     */
    goToSpotDetail(comment) {
      this.$store.commit('DokoikuStore/initSpotDetailInfo')
      this.$store.commit('DokoikuStore/setSpotDetailInfo', {
        key: 'selectedSpot',
        value: comment.spot,
      })
      // 画面を離れる前にページ情報を保持
      this.$store.dispatch('PageControl/saveDokoikuHistoryPage', this.$route)
      navigateTo({name: this.$config.DISPLAY_DOKOIKU_SPOT_DETAIL})
    },
    /**
     * 前画面に遷移
     */
    goToBackPage() {
      this.isShowTagSearchSuggest = false // keep-aliveにより表示状態が保持されるため、明示的に非表示
      goBackDokoiku(this.$route.name)
    },
  },
}
export default TagSearchResult
</script>

<style scooped></style>
